import React, { useEffect, useState } from "react";
import image1 from "../images/image1.jpg";
import image2 from "../images/image2.jpg";
import image3 from "../images/image3.jpg";
import image4 from "../images/image4.jpg";
import addIcon from "../images/add-friend.png";
import image5 from "../images/image5.jpg";
import arrowIcon from "../images/arrow.png";
import fillHeartIcon from "../images/fill heart.png";
import female from "../images/female.png";
import loveIcon from "../images/love.png";
import locationIcon from "../images/location.png";
import { useNavigate } from "react-router-dom";

function About({ id }) {
  const navigate = useNavigate();
  const [bar, setBar] = useState(false);
  const [add, setAdd] = useState(false);
  const names = ["Jiwoo", "Seoyeon", "Haeun", "Minji", "Hyejin"];
  const images = [image1, image2, image3, image4, image5];
  const kms = ["1.2 km", "3.8 km", "5.4 km", "7.1 km", "22.7 km"];
  const heights = ["155 cm", "162 cm", "170 cm", "158 cm", "175 cm"];
  const ages = ["24 yr", "17 yr", "21 yr", "28 yr", "19 yr"];
  const weights = ["48 kg", "52 kg", "57 kg", "61 kg", "65 kg"];
  const locations = [
    "Incheon, South Korea",
    "Daegu, South Korea",
    "Seoul, South Korea",
    "Busan, South Korea",
    "Jeonju, South Korea",
  ];
  const handleLink = () => {
    navigate("/");
  };

  useEffect(() => {
    if (id == null) {
      navigate("/");
    }
  });

  const handleConnect = () => {
    setTimeout(() => {
      setBar(false);
      setAdd(false);
      navigate("/");
    }, 1000);
  };

  return (
    <div className="h-[36rem]  relative flex flex-col items-start  w-[22rem] rounded-xl bg-[#ffffff]">
      <img
        src={images[id]}
        alt="person"
        className="h-[20rem] bg-cover w-full rounded-xl"
      />
      <img
        alt="arrowIcon"
        src={arrowIcon}
        onClick={handleLink}
        className="absolute left-4 cursor-pointer top-4"
      />
      <img
        alt="heartIcon"
        src={fillHeartIcon}
        className="absolute cursor-pointer h-[1rem] right-4 top-4"
      />

      <span className="flex flex-row gap-2 ">
        <h2 className="ml-4 mt-4 text-2xl font-semibold">{names[id]}</h2>
        <img src={female} alt="Gender" className="h-[1.20rem] mt-5" />
      </span>
      <span className="flex flex-row ml-[16.50rem] gap-2">
        <img src={locationIcon} alt="locationIcon" className="h-[1.20rem]" />
        <p>{kms[id]}</p>
      </span>
      <p className="ml-4 tracking-wider text-lg text-[rgba(0,0,0,0.5)]">
        {locations[id]}
      </p>
      <div className="flex flex-row w-full mt-4 gap-12  justify-around pl-2 pr-2 ">
        <div className="flex pl-3  pr-3 pt-2 pb-2 rounded-xl flex-col bg-[#EBEDEF]">
          <p className="font-medium">Age</p>
          <p>{ages[id]}</p>
        </div>
        <div className="flex pl-3  pr-3 pt-2 pb-2 rounded-xl flex-col bg-[#EBEDEF]">
          <p className="font-medium">Height</p>
          <p>{heights[id]}</p>
        </div>
        <div className="flex pl-3  pr-3 pt-2 pb-2 rounded-xl flex-col bg-[#EBEDEF]">
          <p className="font-medium">Weight</p>
          <p>{weights[id]}</p>
        </div>
      </div>
      <div className="w-full flex flex-row gap-3  absolute bottom-3 left-4">
        <button
          onClick={() => {
            setAdd(true);
            handleConnect();
          }}
          className="bg-[hsla(240,46%,93%,1)] rounded-lg h-[2.50rem] w-[28%]"
        >
          Follow
        </button>
        <button
          onClick={() => {
            setBar(true);
            handleConnect();
          }}
          className="bg-[#FE1B7A] text-white h-[2.50] rounded-lg w-[60%] "
        >
          Connect
        </button>
      </div>

      <div
        className={
          bar
            ? "top-0 h-full transition-all duration-500 ease-in-out flex justify-center items-center  absolute z-5  bg-[#FE1B7A] rounded-xl w-full"
            : ""
        }
      >
        {bar ? <img src={loveIcon} className="h-[4rem]" alt="loveIcon" /> : ""}
      </div>
      <div
        className={
          add
            ? "top-0 h-full transition-all duration-500 ease-in-out flex justify-center items-center  absolute z-5  bg-[hsla(240,46%,93%,1)] rounded-xl w-full"
            : ""
        }
      >
        {add ? <img src={addIcon} className="h-[4rem]" alt="addIcon" /> : ""}
      </div>
    </div>
  );
}

export default About;
